import { useEffect, useState } from "react";

export default function CrashProbe() {
  const [msg, setMsg] = useState<string | null>(null);
  useEffect(() => {
    const onErr = (e: ErrorEvent) => setMsg(e.message || String(e.error || e));
    const onRej = (e: PromiseRejectionEvent) =>
      setMsg(
        String(
          (e as any).reason?.message ||
            (e as any).reason ||
            "Unhandled rejection"
        )
      );
    window.addEventListener("error", onErr);
    window.addEventListener("unhandledrejection", onRej);
    return () => {
      window.removeEventListener("error", onErr);
      window.removeEventListener("unhandledrejection", onRej);
    };
  }, []);
  if (!msg) return null;
  return (
    <div
      style={{
        position: "fixed",
        left: 8,
        bottom: 8,
        zIndex: 9999,
        background: "#fff",
        padding: 8,
        border: "1px solid #000",
        maxWidth: 480,
      }}
    >
      <strong>Runtime error:</strong>
      <div style={{ whiteSpace: "pre-wrap" }}>{msg}</div>
    </div>
  );
}
